
import he from 'he';

export function stripHtml(html) {
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
}


export function useNumericInput(formData, setFormData) {
  return (e) => {
    const { name, value } = e.target;
    if (/^\d*$/.test(value)) {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };
}



export function cleanTitle(title) {
  const decoded = he.decode(title);
  const stripped = decoded.replace(/<[^>]*>/g, '');
  return stripped;
}